<div class="relative">
  <button
    type="button"
    (click)="toggle()"
    class="relative -m-1.5 flex items-center p-1.5 text-gray-500 hover:text-gray-700 focus-visible:outline-mango"
    aria-label="Notifications"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="h-6 w-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
      />
    </svg>

    @if (permissionGranted() && unreadCount() > 0) {
      <span
        class="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-mango-red707 px-1 text-[10px] font-semibold leading-none text-white"
      >
        {{ unreadCount() > 99 ? '99+' : unreadCount() }}
      </span>
    }
  </button>

  @if (open()) {
    <div
      class="absolute right-0 z-20 mt-2.5 w-80 origin-top-right rounded-lg bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
    >
      <div
        class="flex items-center justify-between border-b border-gray-100 px-4 pb-2"
      >
        <span class="text-sm font-semibold text-gray-900">Notifications</span>
        @if (unreadCount() > 0) {
          <button
            type="button"
            (click)="inbox.markAllRead()"
            class="text-xs text-mango hover:underline"
          >
            Mark all as read
          </button>
        }
      </div>

      @if (!permissionGranted()) {
        <div class="flex flex-col items-center gap-3 px-4 py-8 text-center">
          <div class="flex h-10 w-10 items-center justify-center rounded-full bg-mango-lightOrange">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-mango">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
            </svg>
          </div>
          <p class="text-sm font-medium text-gray-700">Notifications are disabled</p>
          <p class="text-xs text-gray-400">Enable notifications to see updates here.</p>
          <button
            mango-button
            type="button"
            (click)="enableNotifications()"
            [disabled]="enablingNotifications()"
          >
            @if (enablingNotifications()) {
              <span spin loadingText="Enabling"></span>
            } @else {
              Enable Notifications
            }
          </button>
        </div>
      } @else {
        <div #inboxContainer class="max-h-64 overflow-y-auto" (scroll)="onScroll($event)">
          @if (notifications().length > 0) {
            @for (n of notifications(); track n.id) {
              <button
                type="button"
                (click)="handleNotificationClick(n)"
                class="flex w-full flex-col gap-1 border-b border-gray-50 px-4 py-3 text-left transition-colors"
                [class]="n.read_at === null ? 'bg-white hover:bg-gray-50' : 'bg-gray-50 hover:bg-gray-100'"
              >
                @if (n.image_url) {
                  <img
                    [src]="n.image_url"
                    [alt]="n.title || 'Notification'"
                    class="mb-1 h-28 w-full rounded-md object-cover"
                    loading="lazy"
                  />
                }
                <div class="flex items-start justify-between gap-2">
                  <span
                    class="text-sm font-medium"
                    [class.text-gray-900]="n.read_at === null"
                    [class.text-gray-400]="n.read_at !== null"
                  >
                    {{ n.title || 'Notification' }}
                  </span>
                  @if (n.read_at === null) {
                    <span class="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-mango"></span>
                  }
                </div>
                @if (n.message) {
                  <span class="text-xs text-gray-500">{{ n.message }}</span>
                }
                <span class="text-[11px] text-gray-400">
                  {{ n.created_at | date: 'medium' }}
                </span>
              </button>
            }

            <div #sentinel class="h-1 w-full"></div>

            @if (inbox.loading()) {
              <div class="flex items-center justify-center gap-2 py-3 text-xs text-gray-400">
                <svg class="h-3.5 w-3.5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                </svg>
                Loading…
              </div>
            }
          } @else {
            <div class="px-4 py-8 text-center text-sm text-gray-400">
              You're all caught up.
            </div>
          }
        </div>
      }
    </div>
  }
</div>
